<template>
  <div class="custom-form-page">

    <div class="banner top-banner">
      <div class="banner-desc">
        <div class="title">{{ $t('custom_form_page.banner_title') }}</div>
        <div class="sub-title">{{ $t('custom_form_page.banner_subtitle') }}</div>
      </div>
      <Banner loc="4" :baseBtn="false"/>
    </div>  

    <CaptionBar :title="$t('custom_form_page.caption_bar')" subTitle="CUSTOMIZE" />

    <div class="c-layout">
      <div class="page-title">{{ $t(`custom_form_page.page_title_${step}`) }}</div>
      <div class="page-container">
        <div class="page-right">
          <div class="steps">
            <div class="line-bg show-on-pad"></div>
            <div class="line show-on-pad" :style="{ width: getLineWidth }"></div>
            <div class="step-item"><span class="step-title hide-on-pad" :class="{ active:step=='1' }">{{ $t('custom_form_page.step1') }}</span><span class="step-index show-on-pad-flex" :class="{ active:step>='1' }">1</span></div>
            <div class="step-item"><span class="step-title hide-on-pad" :class="{ active:step=='2' }">{{ $t('custom_form_page.step2') }}</span><span class="step-index show-on-pad-flex" :class="{ active:step>='2' }">2</span></div>
            <div class="step-item"><span class="step-title hide-on-pad" :class="{ active:step=='3' }">{{ $t('custom_form_page.step3') }}</span><span class="step-index show-on-pad-flex" :class="{ active:step>='3' }">3</span></div>
            <div class="step-item"><span class="step-title hide-on-pad" :class="{ active:step=='4' }">{{ $t('custom_form_page.step4') }}</span><span class="step-index show-on-pad-flex" :class="{ active:step>='4' }">4</span></div>
            <div class="step-item"><span class="step-title hide-on-pad" :class="{ active:step=='5' }">{{ $t('custom_form_page.step5') }}</span><span class="step-index show-on-pad-flex" :class="{ active:step>='5' }">5</span></div>
          </div>
          <div class="step-container  search-block" v-show="step==1">
            
            <div class="step-content">
              <div class="step-block">STEP1 | {{ $t('custom_form_page.step_title') }}</div>
              <div class="area-block">
                <div class="area-img" :class="{ active: chooseBarea==index }" v-for="(item,index) in areaimg" :key="index+'_area_img'">
                  <picture>
                    <source :srcset="item.mob" media="(max-width: 992px)">
                    <img class="img-responsive" :src="item.pc" alt />
                  </picture>
                </div>
              </div>
              <div class="barea-block">
                <div class="barea-item" @click="chooseBarea=index;chooseprovince=''" :class="{ active: chooseBarea===index }" v-for="(item,index) in areaMap" :key="index+'_barea'">{{ item.name }}</div>
              </div>
            </div>
            <div class="step-content">
              <div class="step-block">STEP2 | {{ $t('custom_form_page.step_title') }}</div>
              <div class="barea-block">
                <div class="barea-item" @click="chooseprovince=index" :class="{ active: chooseprovince===index }" v-for="(item,index) in areaMap[chooseBarea].province" :key="index+'_barea'">{{ item.name }}</div>
              </div>
              <div class="page-line"></div>
            </div>
            <div class="btn btn-orange submit " @click="handlePcSearchBtn"><Icon type="search" @clickevent="handlePcSearchBtn" />{{ $t('btns.search_store') }}</div>
            <!-- <div class="btn btn-orange submit float-bottom show-on-pad-flex" @click="handleMobSearchBtn"><Icon type="search" @clickevent="handleMobSearchBtn" />{{ step==3?'搜寻经销点':'下一步' }}</div> -->
          </div>
          <div class="step-container result-list-block" v-show="step==2" v-loading="isloading">
            <div class="result-search-item">
              <div class="search-item">{{ $t('custom_form_page.range') }}：{{ getChooseBarea }}</div>
              <div class="search-item">{{ $t('custom_form_page.province') }}：{{ getChooseProvince }}</div>
            </div>
            <div class="result-list" v-if="stores.length>0">
              <div class="result-item" v-for="(item,index) in stores" :key="item.retailer_id+'_result_list'">
                <div class="img-block">
                  <img :src="item.photo" alt="location img">
                </div>
                <div class="desc">
                  <p class="title">{{ item.name}}</p>
                  <p class="tel">{{ $t('custom_form_page.tel') }}: {{ item.telphone }}</p>
                  <p class="addr">{{ $t('custom_form_page.addr') }}: {{ getProvince(item.big_area,item.province) }}{{ item.address }}</p>
                  <Icon type="3D" v-if="item.facility.includes(1)"/>
                </div>
                <div class="btn-block">
                  <div class="btn btn-orange" @click="handleChooseStore(index)">{{ $t('btns.order_store') }}</div>
                </div>
              </div>
            </div>
            <div class="no-result" v-else>
              {{ $t('custom_form_page.no_result') }}
            </div>
            <div class="page-btn-block">
              <div class="btn btn-orange btn-back" @click="handleBack">{{ $t('btns.back') }}</div>
            </div>
          </div>

          <div class="step-container store-info" v-show="step==3">
            <div class="step-block">{{ getStoreDetail.name }}</div>
            <div class="store-banner">
              <img :src="getStoreDetail.photo2">
            </div>
            <div class="store-info-block">
              <div class="store-info-detail">
                <div class="store-name">{{ getStoreDetail.name }}</div>
                <p>{{ getProvince(getStoreDetail.big_area,getStoreDetail.province) }}{{ getStoreDetail.address }}</p>
                <p>{{ $t('custom_form_page.tel') }}: {{ checkEmpty(getStoreDetail.telphone) }}</p>
                <p>{{ $t('custom_form_page.open_time') }}: {{ checkEmpty(getStoreDetail.bussinessTime) }}</p>
                <p>{{ $t('custom_form_page.break_date') }}: {{ checkEmpty(getStoreDetail.offTime) }}</p>
                <div class="logos">
                  <div class="logo"><img :src="visa_logo"></div>
                  <div class="logo"><img :src="mastercard_logo"></div>
                  <!-- <div class="logo"><img :src="discover_logo"></div> -->
                  <Icon type="3D" v-if="getStoreDetail.facility && getStoreDetail.facility.includes(1)"></Icon>
                </div>
              </div>
              <div class="store-map">
                <!-- <img :src="mapimg"> -->
                <baidu-map 
                  class="baidu-map" 
                  :center="mapCenter" 
                  :zoom="mapZoom"
                >
                  <bm-marker :position="mapCenter" :dragging="false" animation="BMAP_ANIMATION_BOUNCE" />
                  <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                </baidu-map>
              </div>
            </div>

            <div class="custom-date-picker" v-loading="reserveDateLoading">
              <div class="step-block">{{ $t('custom_form_page.order_time') }}</div>
              <date-picker 
                v-model="chooseDate" 
                valueType="format" 
                :inline="true" 
                :open="true"
                :disabled-date="disabledDate"
                :default-value="defaultDate"
                @change="handleChangeDate"
              ></date-picker>
              <hr>
            </div>
            <div class="custom-time-picker" v-loading="reserveTimeLoading">
              <div class="time-area" v-for="item in timeData" :key="item.title+'_area'" v-show="chooseDate && (timeData[0].timerange.length>0 || timeData[1].timerange.length>0 || timeData[2].timerange.length>0)">
                <div class="time-title">{{ item.title }}</div>
                <div 
                  class="time-btn"
                  :class="{ active: chooseTime==time.name, disabled: disabledReserveTime.includes(time.name) }"
                  v-for="time in item.timerange" 
                  :key="time.name+'_time'" 
                  @click="handleChooseTime($event,time.name)"
                >
                  <span class="disabled-span" v-show="disabledReserveTime.includes(time.name)">{{ $t('custom_form_page.is_order') }}</span>
                  {{ time.name }}
                </div>
              </div>
              <div class="no-data" v-show="!chooseDate">
                {{ $t('custom_form_page.choose_date') }}
              </div>
              <div class="no-data" v-show="chooseDate && timeData[0].timerange.length==0 && timeData[1].timerange.length==0 && timeData[2].timerange.length==0">
                {{ $t('custom_form_page.no_date_can_choose') }}
              </div>
            </div>
            <div class="page-btn-block">
              <div class="btn btn-orange btn-back" @click="handleBack">{{ $t('btns.back') }}</div>
              <div class="btn btn-orange" @click="handleDateTimeDone">{{ $t('btns.submit') }}</div>
            </div>
          </div>

          <div class="step-container check-order" v-show="step==4">
            <div class="step-block">{{ $t('custom_form_page.order_info') }}</div>
            <div class="check-detail">
              <div class="detail-item">
                <div class="item-title">{{ $t('custom_form_page.order_name') }}</div>
                <div class="item-content">{{ userInfo.user.username }}</div>
              </div>
              <div class="detail-item">
                <div class="item-title">{{ $t('custom_form_page.order_store') }}</div>
                <div class="item-content">{{ getStoreDetail.name }}</div>
              </div>
              <div class="detail-item">
                <div class="item-title">{{ $t('custom_form_page.order_addr') }}</div>
                <div class="item-content">{{ getChooseProvince }}{{ getStoreDetail.address }}</div>
              </div>
              <div class="detail-item">
                <div class="item-title">{{ $t('custom_form_page.order_tel') }}</div>
                <div class="item-content">{{ userInfo.user.phone }}</div>
              </div>
              <div class="detail-item">
                <div class="item-title">{{ $t('custom_form_page.order_mobile') }}</div>
                <div class="item-content">{{ userInfo.user.mobile }}</div>
              </div>
              <div class="detail-item">
                <div class="item-title">{{ $t('custom_form_page.order_remark') }}</div>
                <div class="item-content"><textarea  width="100%" rows="3" v-model="customRemark"></textarea></div>
              </div>
            </div>
            <div class="page-btn-block">
              <div class="btn btn-orange btn-back" @click="handleBack">{{ $t('btns.back') }}</div>
              <div class="btn btn-orange" @click="submitCustomOrder">{{ $t('btns.submit') }}</div>
            </div>
          </div>
  
          <div class="step-container success-order" v-show="step==5">
            <div class="step-block">{{ $t('custom_form_page.order_info') }}</div>
            {{ $t('custom_form_page.order_success1') }}<br><br>{{ $t('custom_form_page.order_success2') }} {{chooseDate}} {{chooseTime}}<br><br>{{ $t('custom_form_page.order_success3') }}<br>{{ $t('custom_form_page.order_success4') }}{{ getStoreDetail.telphone }}<br>「{{ getStoreDetail.name }}」<br>{{ $t('custom_form_page.order_success5') }}
            <div class="bg-img">
              <img :src="done_img">
            </div>
            <div class="page-btn-block">
              <div class="btn btn-orange" @click="handleBackStepOne">{{ $t('btns.back_to_home') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from "moment";
import { mapState } from 'vuex'
var myGeo = new BMap.Geocoder(); 



import CaptionBar from "@/components/CaptionBar";
import Banner from "@/components/Banner";
import { reserveCustom, getReserveTime, getLocations, getReserveDate } from '@/api'
import { cloudLoading } from "@/utils/tools.js";


import img01_mob from './images/01.png'
import img01 from './images/01@2x.png'
import img02_mob from './images/02.png'
import img02 from './images/02@2x.png'
import img03_mob from './images/03.png'
import img03 from './images/03@2x.png'
import img04_mob from './images/04.png'
import img04 from './images/04@2x.png'
import img05_mob from './images/05.png'
import img05 from './images/05@2x.png'
import img06_mob from './images/06.png'
import img06 from './images/06@2x.png'
import img07_mob from './images/07.png'
import img07 from './images/07@2x.png'
import fakeImg from './images/001-098@2x.png'
import storebanner from './images/storebanner.png'

import visa_logo from './images/visa_logo.png'
import mastercard_logo from './images/mastercard_logo.png'
import discover_logo from './images/discover_logo.png'
import done_img from './images/done.png'

  export default {
    name: 'custom-form',
    data() {
      return {
        fakeImg,storebanner,visa_logo,mastercard_logo,discover_logo,done_img,
        areaimg: [
          { pc: img01, mob: img01_mob },
          { pc: img02, mob: img02_mob },
          { pc: img03, mob: img03_mob },
          { pc: img04, mob: img04_mob },
          { pc: img05, mob: img05_mob },
          { pc: img06, mob: img06_mob },
          { pc: img07, mob: img07_mob },
        ],
        areaMap: this.$t('area'),
        // timeData: [
        //   { title: '上午',timerange: [{name: '10:00'},{name: '10:30'},{name: '11:00'},{name: '11:30'}]},
        //   { title: '下午',timerange: [{name: '13:00'},{name: '13:30'},{name: '14:00'},{name: '15:00'},{name: '16:00'},{name: '17:00'}]},
        //   { title: '夜间',timerange: [{name: '19:00'},{name: '20:00'},{name: '20:30'},{name: '21:00'}]}
        // ],
        timeData: [
          { title: this.$t('custom_form_page.morning'),timerange: []},
          { title: this.$t('custom_form_page.afternoon'),timerange: []},
          { title: this.$t('custom_form_page.evening'),timerange: []}
        ],
        chooseBarea:0,
        chooseprovince: '',
        isloading: false,
        step: 1,
        stores:[],
        // booking_date: [],
        // booking_time: [],
        defaultDate: new Date(),
        mapCenter: {lng:0,lat:0},
        mapZoom: 18,
        chooseStore: '',
        chooseDate: null,
        chooseTime: '',
        customRemark: '',
        reserveData: '', // 可预约的日期
        reserveDateLoading: true,
        reserveTimeLoading: false,
        disabledReserveTime: [], // 不可以选择的时间
      }
    },
    components: {
      CaptionBar,DatePicker,Banner
    },
    filters: {
      
    },
    computed: {
      ...mapState(['userInfo']),
      getLineWidth() {
        switch(this.step) {
          case 1:
            return '8%';
            break;
          case 2:
            return '25%';
            break;
          case 3:
            return '42%';
            break;
          case 4:
            return '60%';
            break;
          case 5:
            return 'calc(100% - 32px)';
            break;
        }
      },
      getChooseBarea() {
        if(this.chooseBarea!=='') {
          return this.areaMap[this.chooseBarea].name;
        }else{
          return '';
        }
      },
      getChooseProvince() {
        if(this.chooseprovince!=='') {
          return this.areaMap[this.chooseBarea].province[this.chooseprovince].name;
        }else{
          return '';
        }
      },
      getStoreDetail() {
        if(this.chooseStore!==''  && this.stores.length>0) {
          return this.stores[this.chooseStore];
        }else{
          return '';
        }
      },
      // async getBookingTime() {
      //   this.disabledReserveTime
      //   this.chooseDate

      //   return [];
      // },
    },
    methods: {
      checkEmpty(value) {
        if(String(value).trim() != '' && value != null) {
          return value;
        }else{
          return this.$t('format.no_supply');
        }
      },
      getProvince(big_area_id,province_id) {
        // console.log('big_area_id',big_area_id);
        const area = this.areaMap.filter(item => item.id==big_area_id);
        // console.log('area',area);
        if(area.length==0) return this.$t('format.error');
        const province = area[0].province.filter(item => item.id==province_id);
        if(province.length>0){
          return province[0].name;
        }else{
          return this.$t('format.error');
        }
      },
      handlePcSearchBtn() {
        this.searchLocation();
      },
      handleMobSearchBtn() {
        console.log('this.step',this.step);
        if(this.step==1) {
          this.step +=1;
          window.scrollTo({'behavior': 'smooth', 'top': 400})
          return;
        }
        if(this.step==2) {
          if(!this.chooseprovinc==='') {
            this.$message({
              message: this.$t('alert_message.choose_area'),
              type: 'warning'
            });
            return;
          }
          // 搜寻
          window.scrollTo({'behavior': 'smooth', 'top': 400})
          this.searchLocation();
        }
      },
      async searchLocation() {
        const user = this.userInfo.user;
        
        if(!user.name || !user.mobile || !user.zip || !user.province || !user.city || !user.area || !user.address) {
          this.$message({
            message: this.$t('alert_message.to_edit_userinfo'),
            type: "warning",
          })
          return;
        }
        if(this.chooseprovince!=='') {
          this.step = 2;
          this.isloading = true;
          const bigarea = this.areaMap[this.chooseBarea].id;
          const province = this.areaMap[this.chooseBarea].province[this.chooseprovince].id;
          // 送出api
          const { store } = await getLocations({ bigarea,province });
          // 整理一下 facility 有出现1的话就显示3D图片
          store.map(item => {
            const newFacility = JSON.parse(item.facility);
            return { ...item, facility:newFacility }
          })
          this.stores = store;
          // this.booking_date = booking_date;
          // this.booking_time = booking_time;
          // this.defaultDate = new Date(booking_date[0]);
          window.scrollTo({'behavior': 'smooth', 'top': 400})
          this.isloading = false;
        }else{
          this.$message({
            message: this.$t('alert_message.choose_area'),
            type: 'warning'
          });
          return;
        }
      },
      handleBack() {
        this.step = this.step-1;
      },
      async handleChooseStore(index) {
        this.chooseStore = index;
        const store = this.stores[index];
        const address = `${this.getChooseProvince}${store.address}`;

        myGeo.getPoint(address, (point) => {      
            if (point) {
                this.mapCenter = point;
            }      
        },this.stores[index].province);
        this.step = 3;
        window.scrollTo({'behavior': 'smooth', 'top': 400})
        // 取得可预约日期
        this.handleGetReserveDate();
      },
      handleChooseTime(e,time) {
        if(e.target.classList.contains('disabled')) return;
        this.chooseTime = time;
      },
      // 取得可预约日期
      async handleGetReserveDate() {
        this.chooseDate = null;
        this.chooseTime = null;
        const store = this.stores[this.chooseStore];
        // 取得可预约的日期
        const res = await getReserveDate({ retailer_id: store.retailer_id });
        console.log(res);
        const { data:reserveData } = res;
        this.reserveData = reserveData;
        this.changeTimeData();
        this.reserveDateLoading = false;
      },
      handleDateTimeDone() {
        if(this.chooseDate && this.chooseTime !== '') {
          this.step = 4;
          window.scrollTo({'behavior': 'smooth', 'top': 400})
        }else{
          this.$message({
            message: this.$t('alert_message.choose_datetime'),
            type: 'warning'
          });
          return;
        } 
      },
      async submitCustomOrder() {
        const loading = cloudLoading();
        const data = {
          store_id: this.getStoreDetail.store_id,
          member_id: this.userInfo.user.id,
          retailer_id: this.getStoreDetail.retailer_id,
          booking_date: this.chooseDate,
          booking_time: this.chooseTime,
          telephone: this.userInfo.user.phone,
          mobile: this.userInfo.user.mobile,
          country_id: this.userInfo.user.country_id,
          province: this.userInfo.user.province,
          city: this.userInfo.user.city, 
          area: this.userInfo.user.area,
          address: this.userInfo.user.address,
          zip: this.userInfo.user.zip,
          note: this.customRemark
        }
        try {
          const res = await reserveCustom(data);  
          loading.close();
          window.scrollTo({'behavior': 'smooth', 'top': 400})
          this.step = 5;
        } catch (error) {
          loading.close();
        }
        
        
      },
      handleBackStepOne() {
        window.scrollTo({'behavior': 'smooth', 'top': 400})
        this.chooseBarea = 0;
        this.chooseprovince =  '';
        this.stores = [];
        this.chooseStore =  '';
        this.chooseDate =  null;
        this.chooseTime =  '';
        this.customRemark = '';
        this.step = 1;
      },
      disabledDate(date) {
        let disabled = false;
        const thisDate = new Date(date);
        let { offDate, offWeek, openTime }  = this.reserveData;
        offDate = offDate || [];
        offWeek = offWeek || []; 
        openTime = openTime || [];
        // 判断禁用日期
        const thisDateTxt = moment(thisDate).format("YYYY-MM-DD");
        if(offDate.includes(thisDateTxt)) disabled = true;
        // 判断禁用星期
        const formatOffWeek = offWeek.map(item => parseInt(item));
        if(formatOffWeek.includes(thisDate.getDay())) disabled = true;
        return disabled;
        // chooseDate
        // const thisDateTxt = moment(thisDate).format("YYYY-MM-DD");
        // const okdate = this.booking_date;
        // return okdate.includes(thisDateTxt);
      },
      changeTimeData() {
        // 整理一下拿到的openTime分别放到上午和下午和晚上 00:00 - 11:00为上午，12:00 - 18:00为下午，19:00 - 23:00为夜间
        const newTimeData = JSON.parse(JSON.stringify(this.timeData));
        // 先清空
        newTimeData[0].timerange = [];
        newTimeData[1].timerange = [];
        newTimeData[2].timerange = [];
        const morning = ["00:00","00:30","01:00","01:30","02:00","02:30","03:00","03:30","04:00","04:30","05:00","05:30","06:00","06:30","07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00"];
        const noon = ["12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00"];
        const night = ["19:00","19:30","20:00","20:30","21:00","21:30","22:00","22:30","23:00"];
        const openTime = this.reserveData.openTime || [];
        openTime.forEach(time => {
          if(morning.includes(time)) { 
            newTimeData[0].timerange.push({name:time});
            return;
          }
          if(noon.includes(time)) { 
            newTimeData[1].timerange.push({name:time});
            return;
          }
          if(night.includes(time)) { 
            newTimeData[2].timerange.push({name:time});
            return;
          }
        });
        this.timeData = newTimeData;
      },
      // 选择日期后
      handleChangeDate(e){
        console.log(e);
        // 取得可以预约的时间
        this.handleGetCanReserveTime();
      },
      // 取得可以预约的时间
      async handleGetCanReserveTime() {
        const store = this.stores[this.chooseStore];
        this.chooseTime = null;
        this.reserveTimeLoading = true;
        // 取得可预约的时间
        const res = await getReserveTime({ retailer_id: store.retailer_id, booking_date: this.chooseDate });
        console.log('can ReserveTime',res);
        const { list } = res;
        const canNotReserveTimeDtata = list.map(item => item.booking_time.slice(0,-3));
        this.disabledReserveTime = canNotReserveTimeDtata;
        // this.disabledReserveTime = ["12:00"];
        this.reserveTimeLoading = false;
      }
    }
  }
</script>

<style lang="less" scoped>
.custom-form-page {
  .banner {
    position: relative;
    // padding-top: calc(100%/1440*758);
    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      height: 100%;
      display: block;
    }
    .banner-desc {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      color: white;
      background: rgba(255,255,255,.2);
      // padding: 6rem 10rem;
      text-align: center;
      word-break: keep-all;
      height: 60%;
      width: 620px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 10;
      .title {
        font-size: 5.5rem;
        font-weight: 400;
        margin-bottom: 10px;
      }
      .sub-title {
        font-size: 4.5rem;
        font-weight: 300;
      }
    }
    @media (max-width: 992px) {
      .banner-desc {
        // top: unset;
        bottom: 60px;
        transform: translate(-50%,-50%);
        // padding: 5rem 1rem;
        width: 85%;
        .title {
          font-size: 3rem;
        }
        .sub-title {
          font-size: 2rem;
        }
        &::after {
          content: '';
          position: absolute;
          width: calc(100% + 20px);
          height: calc(100% + 10px);
          top: -5px;
          left: -10px;
          border: 1px solid white;
        }
      }
    }
  }

  /deep/ .caption-bar-comp {
    transform: translateY(-25px);
    &.flow-title {
      transform: translateY(0);
    }
    @media (max-width: 992px) {
      transform: translateY(-15px);
      &.flow-title {
        transform: translateY(0);
      }
    }
    .caption-line {
      width: 100%;
    }
  }

  .page-title {
    margin-bottom: 0;
  }
  .page-container {
    border-top: unset;
  }
  .step-block {
    background: #F0F0F0;
    padding: 20px;
    text-align: center;
    margin-bottom: 30px;
  }
  .steps {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    position: relative;
    margin-bottom: 20px;
    .step-item {
      font-weight: 400;
      color: #707070;
      & .step-title.active {
        color: #FF5214;

      }
    }
    @media (max-width: 992px) {
      padding-left: 0%;
      padding: 0 16px;
      border-bottom: unset;
      .line {
        position: absolute;
        width: calc(100% - 32px);
        height: 3px;
        background: #FF5214;
        border-radius: 3px;
        z-index: -1;
        top: 50%;
        transform: translateY(-50%);
      }
      .line-bg {
        position: absolute;
        width: calc(100% - 32px);
        height: 3px;
        background: #F5F4F8;
        border-radius: 3px;
        z-index: -1;
        top: 50%;
        transform: translateY(-50%);
      }
      .step-item:nth-child(3) {
        margin-left: 30px;
      }
      .step-item:nth-last-child(1) {
        margin-right: 30px;
      }
      .step-index {
        background: white;
        color:#E6E6E6;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        border: 2px solid #E6E6E6;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          height: 28px;
          width: 28px;
          left: -5px;
          top: -5px;
          border: 3px solid white;
          border-radius: 50%;
        }
      }
      .step-item {
        font-weight: 400;
        color: #707070;
        & .step-index.active {
          background: #FF5214;
          border: 2px solid #FF5214;
          color: white;
        }
      }
    }
  }
  .page-right {
    width: 100%;
  }
  .area-block {
    padding-bottom: 30px;
    width: 50%;
    margin: auto;
    .area-img {
      display: none;
      width: 100%;
      &.active {
        display: block;
      }
    }
  }
  .barea-block {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    width: 50%;
    margin: auto;
    .barea-item {
      flex: 0 0 calc(25% - 15px);
      margin-right: 20px;
      border: 1px solid #101010;
      text-align: center;
      padding: 10px 0;
      margin-bottom: 20px;
      cursor: pointer;
      &:nth-child(4n) {
        margin-right: 0;
      }
      &.active {
        background: #EC4F00;
        border: 1px solid #EC4F00;
        color: white;
      }
    }
  }
  .page-line {
    width: 100%;
    height: 1px;
    background: #E6E6E6;
    margin-top: 60px;
    margin-bottom: 30px;
  }
  .submit {
    width: 160px;
    line-height: 24px;
    margin: auto;
    margin-bottom: 60px;
    .cloud-icon {
      fill: white;
      margin-right: 5px;
    }
    &.float-bottom {
      position: fixed;
      width: 100%;
      bottom: 0;
      left: 0;
      margin-bottom: 0;
      z-index: 10;
    }
  }
  .result-list-block {
    margin-bottom: 30px;
    .result-search-item {
      background: #F0F0F0;
      display: flex;
      margin-bottom: 30px;
      padding-left: 20px;
    }
    .search-item {
      text-align: center;
      padding: 20px 20px;
    }
    .result-list {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
      margin-bottom: 60px;
      .result-item {
        margin-right: 20px;
        flex: 0 0 calc(33% - 10px);
        margin-bottom: 20px;
        position: relative;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
      .img-block {
        position: relative;
        padding-top: calc(100%/350*200);
        overflow: hidden;
        img {
          position: absolute;
          width: 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
      }
      .desc {
        color: #707070;
        padding: 10px 0;
        .title {
          font-weight: 400;
          margin-bottom: 10px;
        }
        .tel {
          margin-bottom: 5px;
        }
        .addr {
          margin-bottom: 20px;
        }
      }
      .btn-block {
        display: flex;
        justify-content: flex-end;
        .btn {
          width: 125px;
        }
      }
      .cloud-icon {
        height: 44px;
        width: 44px;
        fill: #707070;
        position: absolute;
        bottom: -10px;
        left: 0;
      }
    }
  }
  .btn-back {
    // width: 125px;
    // margin: auto;
    // margin-top: 60px;
    // margin-bottom: 40px;
    // @media (max-width: 992px) {
    //   position: fixed;
    //   width: 100%;
    //   bottom: 0;
    //   left: 0;
    //   z-index: 1;
    //   margin: 0;
    // }
  }
  @media (max-width: 992px) {
    .step-content {
      // display: none;
      // &.active {
      //   display: block;
      // }
    }
    .step-block {
      margin-left: -16px;
      margin-right: -16px;
    }
    .area-block {
      width: 100%;
    }
    .barea-block { 
      width: 100%;
      .barea-item {
        flex: 0 0 calc(33% - 13px);
        &:nth-child(3n) {
          margin-right: 0;
        }
        &:nth-child(4n) {
          margin-right: 20px;
        }
      }
    }
    .result-list-block {
      .result-search-item {
        margin-left: -15px;
        margin-right: -15px;
        .search-item {
          position: relative;
          &:nth-child(1) {
            &::after {
              content: '';
              position: absolute;
              height: 20px;
              width: 1px;
              background: #707070;
              right: 0;
              top: 17px;
            }
          }
        }
      }
      .result-list {
        .result-item {
          flex: 0 0 100%;
        }
        .img-block {
          padding-top: calc(100%/336*242);
          overflow: hidden;
        }
        .btn-block {
          .btn {
            width: 100%;
          }
        }
        .desc {
          position: relative;
        }
        .cloud-icon {
          bottom: unset;
          top: 10px;
          left: unset;
          right: 0;
        }
      }
    }
  }

  .store-info {
    margin-bottom: 40px;
    .store-banner {
      margin-bottom: 20px;
      @media (max-width: 992px) {
        margin-right: -16px;
        margin-left: -16px;
        margin-bottom: 30px;
      }
      img {
        display: block;
        width: 100%;
      }
    } 
    .store-info-block {
      display: flex;
      margin-bottom: 40px;
      @media (max-width: 992px) {
        flex-direction: column-reverse;
      }
    }
    .store-info-detail {
      flex: 1;
      .store-name {
        color: #FF5214;
        font-weight: 400;
        font-size: 2rem;
        margin-bottom: 20px;
        @media (max-width: 992px) {
          font-size: 1.5rem;
        }
      }
      p {
        margin-bottom: 20px;
      }
      .logos {
        display: flex;
        .logo {
          width: 70px;
          margin-right: 10px;
          @media (max-width: 992px) {
            width: 50px;
          }
          img {
            display: block;
            width: 100%;
          }
        }
        /deep/ .cloud-icon {
          width: 70px;
          height: auto;
          @media (max-width: 992px) {
            width: 50px;
          }
          svg {
            fill: #828282;
            transform: translateY(10px);
            @media (max-width: 992px) {
              transform: translateY(5px);
            }
          }
        }
      }
    }
    .store-map {
      flex: 1;
      img {
        display: block;
        width: 100%;
      }
      .baidu-map {
        width: 100%;
        height: 300px;
      }
      @media (max-width: 992px) {
        margin-right: -16px;
        margin-left: -16px;
        margin-bottom: 20px;
      }
    }
    .custom-date-picker {
      display: flex;
      flex-direction: column;
      justify-content: center;
      /deep/ .mx-datepicker-main {
        border: unset;
        color: black;
        .mx-calendar {
          margin: auto;
          width: 332px;
        }
      }
      /deep/ .mx-table-date .today {
        color: #FF5214;
      }
      /deep/ .mx-calendar-header {
        .mx-btn {
          font-size: 1rem;
          color: black;
          &:hover {
            color: #ff5214;
          }
        }
        .mx-btn-current-month,.mx-btn-current-year {
          color: #ff5214;
          font-size: 1.5rem;
        }
      }
      /deep/ .mx-calendar-content {
        height: 296px;
        .cell:hover {
          background: #ffd7c8;
          color: black;
          border-radius: 50%;
        }
        .cell.active {
          color: white;
          background: #FF5214;
          border-radius: 50%;
        }
        .cell.disabled {
          background: unset;
          color: #ccc;
        }
        .cell.disabled :hover{
          // background: #f3f3f3;
        }
      }
      /deep/ .mx-table-date td, .mx-table-date th {
        font-size: 1rem;
        height: 44px;
      }

      hr {
        width: 100%;
        border: unset;
        border-bottom: 1px solid #bbb;
      }
      
      
    }
    .custom-time-picker {
      display: flex;
      margin-top: 30px;
      margin-bottom: 20px;
      .time-area {
        flex: 1;
        margin-right: 20px;
        &:nth-last-child(1) {
          margin-right: 0;
        }
      }
      .time-title {
        text-align: center;
        margin-bottom: 30px;
        font-weight: 400;
      }
      .time-btn {
        border: 1px solid black;
        padding: 16px 0;
        margin-bottom: 20px;
        text-align: center;
        font-weight: 400;
        font-size: 0.8rem;
        cursor: pointer;
        &.disabled {
          // opacity: .3;
          border: 1px solid rgba(0,0,0,.33);
          color: rgba(0,0,0,.3);
          cursor: no-drop;
          position: relative;
          overflow: hidden;
        }
        &.active {
          color: white;
          background: #ff5214;
        }
        .disabled-span {
          background: #ec4f01;
          padding: 3px 17px;
          position: absolute;
          opacity: 1;
          top: 3px;
          right: -18px;
          transform: rotate(35deg);
          color: white;
        }
      }
    }
    .btn {
      width: 125px;
      margin: auto;
      // @media (max-width: 992px) {
      //   position: fixed;
      //   width: 100%;
      //   bottom: 0;
      //   left: 0;
      //   z-index: 1;
      // }
    }
  }

  .check-order {
    margin-bottom: 40px;
    .check-detail {
      border-top: 1px solid #E6E6E6;
      margin-bottom: 30px;
      .detail-item {
        border-bottom: 1px solid #E6E6E6;
        display: flex;
        @media (max-width: 992px) {
          flex-direction: column;
          margin-bottom: 10px;
        }
      }
      .item-title {
        background: #F3F3F3;
        color: black;
        padding: 30px 20px;
        width: 200px;
        display: flex;
        align-items: center;
        @media (max-width: 992px) {
          width: 100%;
          padding: 10px 20px;
          justify-content: center;
        }
      }
      .item-content {
        padding: 30px 20px;
        flex: 1;
        textarea {
          width: 100%;
          border: 1px solid #E6E6E6;
        }
        @media (max-width: 992px) {
          padding: 10px 0px;
          font-size: 1.2rem;
          text-align: center;
        }
      }
    }
    .btn {
      width: 125px;
      margin: auto;
      // @media (max-width: 992px) {
      //   position: fixed;
      //   width: 100%;
      //   bottom: 0;
      //   left: 0;
      //   z-index: 1;
      // }
    }
  }

  .success-order {
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: column;
    text-align: center;
    line-height: 1.5rem;
    .step-block {
      width: 100%;
      margin-bottom: 50px;
    }
    .bg-img {
      position: absolute;
      right: 0;
      top: 120px;
      width: 390px;
      @media (max-width: 992px) {
        position: relative;
        top: 0;
        margin-top: 40px;
        width: 100%;
        max-width: 390px;
      }
      img {
        display: block;
        width: 100%;
      }
    }
    .page-btn-block {
      .btn {
        margin-top: 50px;
      }
    }
  }

  .page-btn-block {
    display: flex;
    justify-content: center;
    .btn {
      margin: unset;
      margin-right: 20px;
      width: 125px;
      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
    @media (max-width: 992px) {
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 0;
      z-index: 1;
      .btn {
        width: unset;
        flex: 1;
        margin-right: 0;
      }
    }
  }

}
</style>